import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from '@environments/environment';
import { CandidateEvaluationFeedback } from '@app/model/candidateEvaluationFeedback';
import { SaveCandidateEvaluationFeedbackSerializer } from '../model/serializer/SaveCandidateEvaluationFeedback-serializer';

@Injectable({
  providedIn: 'root'
})
export class SaveCandidateFeedbackEvaluationService extends ApiService<CandidateEvaluationFeedback>{

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview/save-candidate-evaluation-form',
      new SaveCandidateEvaluationFeedbackSerializer());
   }
}
